import { Component, Input, ViewEncapsulation } from '@angular/core';
import { GlobalDataStorage } from 'src/app/share/storages/global-data.storage';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {

    @Input() currentPage: string;
    @Input() year;
    @Input() theme: string;
    
    visibleMenu = false;
    locale: string;

    constructor (
        private globalDataStorage: GlobalDataStorage,
        private router: Router
    ){
        this.locale = this.globalDataStorage.getStorage('locale');
    }

    ngOnInit() {
        console.log(this.currentPage)
    }

    openMenu(): void {
        this.visibleMenu = true;
    }

    closeMenu(): void {
        this.visibleMenu = false;
    }

    routeTo(targetPage: string) {
        switch (targetPage) {
            case 'home':
                this.router.navigate(['/' + this.year + '/home']);
                break;
            case 'corporateAwards':
                this.router.navigate(['/' + this.year + '/corporate-awards']);
                break;
            case 'individualAwards':
                this.router.navigate(['/' + this.year + '/individual-awards']);
                break;
            case 'partnerWithUs':
                this.router.navigate(['/' + this.year + '/partner-with-us']);
                break;
            default:
                break;
        }
    }
}
